// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"6d2baf0d","58":"80e7293f","628":"c8d676b4","988":"c0d90ca0"}[chunkId] + ".chunk.js";
};